import { ChatMessage } from "../../api";
import WorkflowBadge from "../WorkflowBadge/WorkflowBadge";
import styles from "./Footer.module.css"

interface FooterProps {
    selectedConvId: string;
    conversationId: string;
    answers: ChatMessage[];
    useCaseTitle: string;
    showWorkflowBadge: boolean;
}

const Footer = ({selectedConvId, conversationId, answers, useCaseTitle, showWorkflowBadge}: FooterProps) => {

    return (
      <div className={styles.footer}>
        <div className={styles.footerColumn}>
        {(selectedConvId || answers.length > 0) && (
          <div className={styles.exportContainer}>
            <span className={styles.conversationId}>
              <b>Conversation ID:</b> {selectedConvId || conversationId}
            </span>
          </div>
        )}
        <div style={{ display: "flex", gap: "12px" }}>
          <a
            className={styles.privacyLink}
            href="/docs/Privacy statement_INTPA AI Chatbot v2.0_27-02-2026.pdf"
            target="_blank"
          >
            Privacy Policy
          </a>
          <a
            className={styles.privacyLink}
            href="/docs/INTPA AI Assistant - Terms of Use v1.1.pdf"
            target="_blank"
          >
            Terms of Use
          </a>
        </div>
      </div>
      <div className={styles.badgeWrapper}>
        <WorkflowBadge useCaseTitle={useCaseTitle} showWorkflowBadge={showWorkflowBadge} />
      </div>
      </div>
    )
}

export default Footer
